import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const NoteHistoryButton = ({ noteHistory, handler }) => {
  if (!noteHistory || noteHistory.length <= 1) {
    return null
  }
  return (
    <button className="note-history-button" onClick={handler}>
      <FontAwesomeIcon style={{paddingRight: '5px'}}icon={['fas', 'clock-rotate-left']} /> Note History Available ({noteHistory.length})
    </button>
  )
}

export default NoteHistoryButton